import NetworkUtil from "./NetworkUtil";
import Facility, {FacilitySearch} from "../types/Facility";
import {ServerResponse} from "../types/ServerResponse";

export class FacilityAPI{

    public static facilitySearch(filter, page):Promise<{num_pages:number, table_data?:FacilitySearch[],  data:FacilitySearch[]}>{
        return NetworkUtil.makePost("/api/admin/searchFacility?page=" + page, filter);
    }

    // this function appears to be unused ??
    // public static async getFacilities(active:boolean=false):Promise<{label: string, value: number}[]>{
    //     return NetworkUtil.makePost("/api/admin/facilities",{active:active});
    // }

    public static facilityUpsert(facility:Facility):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/facilityUpsert", {facility: facility});
    }
}